let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cTSWX")).then(() => parcelRequire('kdaCi'));